/**
 * ToastHost — H5 `<div id="toast" class="toast">` equivalent.
 *
 * H5 source: index.html toast slot + main.js:9907-9914 `showToast()`.
 * The H5 toast lives directly in the document body (position: fixed
 * makes parent irrelevant). React mounts ToastHost inside AppShell so
 * the device-frame wrapper still renders correctly on tablet/desktop
 * viewports.
 *
 * The container always renders so React Testing Library can target it
 * via `findByRole("status")` (polite default) or `findByRole("alert")`
 * (when severity === "assertive") — `aria-hidden` mirrors H5's
 * transition pattern (.toast → .toast.is-visible).
 *
 * Audit C (a11y, docs/plans/error-empty-loading-audit-2026-05-20.md):
 * severity drives both role and aria-live so error toasts interrupt
 * the SR's current utterance instead of being queued behind a long
 * polite announcement (e.g. RouteAnnouncer page-title update).
 */

import { useToastStore } from "@/shared/stores/useToastStore.js";

export function ToastHost() {
  const message = useToastStore((state) => state.message);
  const visible = useToastStore((state) => state.visible);
  const severity = useToastStore((state) => state.severity);
  const isAssertive = severity === "assertive";

  return (
    <div
      className={`toast${visible ? " is-visible" : ""}`}
      role={isAssertive ? "alert" : "status"}
      aria-live={isAssertive ? "assertive" : "polite"}
      aria-hidden={!visible}
    >
      {message}
    </div>
  );
}
